/* eslint-disable react-hooks/exhaustive-deps */
import { ArtButton, DAOButton } from "components/button";
import Selection, { getWalletOptions } from "components/input/select-input";
import Config from "config";
import { Chain, ContractType, CustomerInterface, TicketUnit } from "interfaces";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "reducer/store";
import { Modal } from "semantic-ui-react";
import { api, ui, utils } from "services";
import { getContract, FTContract } from "services/contract";
import keplrService from "services/keplr";

export default function TicketUnstake({ open, onClose, unit, onSuccess }: any) {
  const [amount, setAmount] = useState(0);
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const user: any = useSelector((state: RootState) => state.user);
  const wallets = useSelector((state: RootState) => state.wallets);
  const [options, setOptions] = useState([]);
  const { t } = useTranslation();
  // @ts-ignore
  const available = user[CustomerInterface[unit]];
  const [cleanFee, setCleanFee] = useState(null);
  const [loadingCleanFee, setLoadingCleanFee] = useState(false);
  const loginType = useSelector((state: RootState) => state.logintype);

  const transferTicket = async (amount: number, unit: TicketUnit, chain: Chain) => {
    try {
      let isWalletConnect = sessionStorage.getItem("isWalletConnect");
      if (isWalletConnect) {
        throw new Error("not_support_walletconnect");
      }
      let { signResult } = await api.getFtSignature(amount, utils.getTicketTypeFromUnit(unit), chain);
      let { message, signature } = signResult;

      if (Config.EtherChain.includes(chain)) {
        FTContract.options.address = getContract(ContractType[unit], chain);
        await FTContract.methods
          .mint(message.amount, message.nonce, message.timestamp, signature)
          .send({ from: message.user_address })
      } else if (Config.CosmosChain.includes(chain)) {
        await keplrService.execute(message.user_address, getContract(ContractType[unit], chain), {
          mint_with_signature: {
            msg: {
              amount: amount.toString(),
              nonce: message.nonce,
              timestamp: message.timestamp.toString(),
            },
            signature
          },
        })
      }
      ui.alertSuccess("Transfer ticket to market success.", "Please wait 5 minutes to update your ticket balance.");
    } catch (err: any) {
      ui.alertFailed("Transfer ticket failed", t(err.message));
    };
  };

  useEffect(() => {
    if (user?.[CustomerInterface.id]) {
      let data = getWalletOptions(wallets) ?? [];
      setOptions(data);
      let idx = data.find((i) => i.value == loginType)
      if (idx) {
        setValue(idx.value)
      } else {
        data.length > 0 && setValue(data[0].value)
      }
    }
  }, [wallets, loginType])
  async function onSubmit() {
    if (!amount) { return }
    setLoading(true);
    let chain = utils.getChainFromLogin(value);
    try {
      await transferTicket(amount, unit, chain)
      onSuccess()
    } catch (err) {
      setLoading(false);
    } finally {
      close();
    }
  }

  function close() {
    setAmount(0);
    setLoading(false);
    onClose();
  }

  const getCleanFee = async () => {
    try {
      setLoadingCleanFee(true);
      if (!amount || isNaN(amount)) {
        setCleanFee(null);
      } else {
        let data: any = await api.getFtCleanFee(utils.getTicketTypeFromUnit(unit), amount);
        setCleanFee(data?.fee ?? null);
      }
    } catch (err) {
      setCleanFee(null);
    } finally {
      setLoadingCleanFee(false);
    }
  }

  useEffect(() => {
    getCleanFee();
  }, [amount])

  return (
    <Modal
      size="small"
      open={open}
      style={{ width: "unset" }}
    >
      <div
        className="max-w-[564px] w-screenn"
      >
        <div className="text-red cursor-pointer absolute float-right right-4 top-3"
          onClick={() => {
            if (!loading) {
              close();
            }
          }}
        >
          <img src="/assets/images/icons/close-popup.png" alt="close" className="" />
        </div>
        <div className="max-w-[564px] w-screen bg-black-secondary pb-8">
          <div>
            <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
              {t("Transfer to market")}
            </div>
            <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-9" />

            <div className="w-11/12 mx-auto">

              <div className="text-center flex mx-auto justify-center w-full rounded-lg mb-3">
                <div className="relative w-full">
                  <div className="flex absolute inset-y-0 left-0 pl-3 pointer-events-none flex-col">
                    <span className="text-gray text-sm mt-1 mr-2">{t("wallet_address")}</span>
                    <div className="flex">
                      <img className="h-6 w-6 mt-1" src={`/assets/images/wallets/metamask.svg`} alt="coin" />
                    </div>
                  </div>
                  <Selection
                    setValue={setValue}
                    options={options}
                    disabled={loading}
                    theme="dark"
                  />
                </div>
              </div>

              <div className="text-center text-white flex mx-auto justify-center w-full overflow-hidden rounded-lg ">
                <div className="relative w-full">
                  <div className="flex absolute inset-y-0 left-0 pl-3 pointer-events-none flex-col">
                    <span className="text-gray text-sm mt-1">{t("amount")}</span>
                    <img className="h-6 w-6 mt-1" src={`/assets/images/items/${unit.replace('_', '-')}.svg`} alt="coin" />
                  </div>
                  <input
                    type="text"
                    className="text-sm font-semibold block w-full h-[54px] pl-11 pt-5 text-[#E4E4E4] border border-r-0 border-input bg-[#1F1D24] rounded-l-md"
                    value={amount}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(e: any) => {
                      let value = e.target.value;
                      value = Number(value) > Number(available) ? available : value;
                      setAmount(value)
                    }}
                  />
                </div>
                <div
                  className="unselectable bg-[#1F1D24] h-[54px] px-4 text-center pt-[19px] font-medium cursor-pointer text-[#E89F01] border border-l-0 border-input rounded-r-md"
                  style={{
                    // borderLeft: "1px solid #7C6F5F",
                  }}
                  color="yellow"
                  onClick={(evt) => {
                    evt.preventDefault();
                    setAmount(available);
                  }}
                >
                  {t("max")}
                </div>
              </div>

              <div className="font-normal text-[#999999] mt-3 text-sm">
                {t("Balance")}: {" "}
                <span>
                  <img className="h-6 w-6 mx-1 inline-block" src={`/assets/images/items/${unit.replace('_', '-')}.svg`} alt="coin" />
                  {utils.convertToInternationalCurrencySystem(available)}
                </span>
              </div>

              <div className="font-normal text-red mt-3">
                {t("Conversion fee")}: {" "}
                <span>
                  <img className="h-6 w-6 mx-1 inline-block" src={`/assets/images/items/mstr-icon.svg`} alt="mstr-icon" />
                  {utils.convertToInternationalCurrencySystem(cleanFee ?? 0, 3)} MSTR
                </span>
              </div>
            </div>

            <div className="flex w-[112px] gap-4 mt-5 text-center items-center mx-auto">
              <DAOButton
                color="white"
                theme="orange"
                className="py-4"
                disabled={!amount || Number(amount) <= 0 || !cleanFee || loadingCleanFee || !user || !user[CustomerInterface.mstr] || cleanFee > user[CustomerInterface.mstr]}
                loading={loading}
                onClick={async () => {
                  await onSubmit();
                }}
              >
                {t("Confirm")}
              </DAOButton>
            </div>
          </div>
        </div>
      </div>
    </Modal >
  );
}
